import {CanMatchFn, Router} from '@angular/router';
import { inject } from '@angular/core';
import {GameService} from "../services/game.service";

export const gamePlayCanMatch: CanMatchFn = async () => {
  const gameInfo = window.localStorage.getItem('gameInfo')
  if (inject(GameService).game) {
    return true
  } else {
    const router = inject(Router);
    if (gameInfo) {
      await inject(GameService).reloadGame()
      return router.parseUrl('/resume-game-play');
    } else {
      return router.parseUrl('/');
    }
  }
};
